import { Link } from "react-router-dom";

function NotFound() {
    return (
        <main id="main" className="main">

            <div className="pagetitle">
                <h1>Not Found Page</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item">
                            <Link to="/">Home</Link>
                        </li>
                        <li className="breadcrumb-item">Not Found</li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard">
                <div className="row">
                    <div className="col-12">
                        <div className="card recent-sales overflow-auto">
                            <div className="card-body text-center">
                                <h1 className="mt-5">Not Found Page</h1>
                                <p>The page you are looking for does not exist.</p>
                                <Link to="/" className="btn btn-primary mt-3">
                                    Go Back Home
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </main>
    );
}

export default NotFound;